var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconArrowLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    transform: "matrix(-1 0 0 1 30 0)",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2444 16.111L18.5768 24.7469C18.6542 24.8272 18.7461 24.8908 18.8473 24.9342C18.9484 24.9776 19.0568 25 19.1663 25C19.2758 25 19.3842 24.9776 19.4853 24.9342C19.5865 24.8908 19.6784 24.8272 19.7558 24.7469C19.8332 24.6667 19.8946 24.5714 19.9365 24.4666C19.9784 24.3618 20 24.2494 20 24.1359C20 24.0225 19.9784 23.9101 19.9365 23.8053C19.8946 23.7004 19.8332 23.6052 19.7558 23.5249L12.0119 15.5L19.7558 7.47506C19.9122 7.31302 20 7.09324 20 6.86407C20 6.63491 19.9122 6.41513 19.7558 6.25308C19.5995 6.09104 19.3874 6 19.1663 6C18.9452 6 18.7331 6.09104 18.5768 6.25308L10.2444 14.889C10.1669 14.9692 10.1054 15.0645 10.0635 15.1693C10.0216 15.2741 10 15.3865 10 15.5C10 15.6135 10.0216 15.7259 10.0635 15.8307C10.1054 15.9355 10.1669 16.0308 10.2444 16.111Z",
    fill: "#B3B8C2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowLeft);
export default __webpack_public_path__ + "static/media/icon_arrow_left.c1ae31e91bba576a7f65b59238984885.svg";
export { ForwardRef as ReactComponent };